export default __webpack_public_path__ + "static/media/hall1.55d95c10.jpeg";